// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"itemContainer--dQvXb","comp":"comp--QrZVF","label":"label--hUyjh"};